import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import autobind from 'autobind-decorator';
import {Link, withRouter, routerShape, locationShape} from 'react-router';

import {cn} from 'spa/css';

import './CountrySelect.less';

import GB from 'spa/images/flags/GB.svg';
import FR from 'spa/images/flags/FR.svg';

import {withI18n} from 'spa/Components/Context';
import OptionsList from 'spa/Components/OptionsList';
import {browserOnly} from 'spa/Components/EnvSplit';

const flags = {GB, FR};
const countries = [
  {
    id: 'GB',
    languages: [
      'EN',
    ],
  },
  {
    id: 'FR',
    languages: [
      'FR',
    ],
  },
];
const options = countries.reduce(
  (options, country) => options.concat(country.languages.map(language => ({
    // name: `${countryNames[country.id]} (${languageNames[language]})`,
    value: `${language}-${country.id}`,
    country: country.id,
    language,
  }))),
  [],
);

@browserOnly
@withRouter
@inject('store')
@observer
@withI18n
class CountrySelect extends React.Component {
  static propTypes = {
    router: routerShape.isRequired,
    location: locationShape.isRequired,
    params: PropTypes.object,
    routes: PropTypes.array,
    store: PropTypes.object,
    fromTop: PropTypes.bool,
    light: PropTypes.bool,
  };

  static contextTypes = {
    createLocaleLink: PropTypes.func,
  };

  state = {isOpen: false};

  componentWillUnmount() {
    this.setState({isOpen: false});
  }

  getCountryName(id) {
    const {i18n} = this.context;
    switch (id) {
    case 'GB':
      return i18n._x('United Kingdom', 'country name');
    case 'FR':
      return i18n._x('France', 'country name');
    default:
      return i18n._x('Unknown', 'country name');
    }
  }

  getLanguageName(id) {
    const {i18n} = this.context;
    switch (id) {
    case 'EN':
      return i18n._x('English', 'language name');
    case 'FR':
      return i18n._x('French', 'language name');
    default:
      return i18n._x('Unknown', 'language name');
    }
  }

  @autobind onClick(event) {
    event.preventDefault();
    this.setState({isOpen: !this.state.isOpen});
  }

  @autobind onClose() {
    this.setState({isOpen: false});
  }

  @autobind onSelect(value) {
    this.setState({isOpen: false});
    const {createLocaleLink} = this.context;
    const country = countries.find(country => country.id === value);
    // select first language in that counrty
    const language = country && country.languages[0] || 'en';
    sessionStorage.removeItem('giftsV2'); // eslint-disable-line no-undef
    window.location = createLocaleLink(`${language}-${value}`);
  }

  @autobind onClickLanguage(event) {
    event.stopPropagation();
    event.preventDefault();

    this.setState({isOpen: false});

    const {createLocaleLink} = this.context;
    const selectedLocaled = event.currentTarget.dataset.locale;
    sessionStorage.removeItem('giftsV2'); // eslint-disable-line no-undef
    window.location = createLocaleLink(selectedLocaled);
  }

  render() {
    const {createLocaleLink} = this.context;
    if (!createLocaleLink) return null;

    const {lc, region} = this.context.i18n;
    const {
      store, router, location, params, routes, fromTop, light, ...rest
    } = this.props;
    return (
      <OptionsList
        hide={!this.state.isOpen}
        containerClassName="CountrySelect"
        name="country-select"
        onClick={this.onClick}
        onClose={this.onClose}
        options={countries.map((country) => {
          const selected = region === country.id;
          return {
            name: (
              <span>
                <img src={flags[country.id]} alt={country.id} className="CountrySelect-flag" />
                {this.getCountryName(country.id)}
              </span>
            ),
            subtext: (
              <div className="CountrySelect-languages">{
                country.languages.map((lang) => {
                  const locale = `${lang}-${country.id}`.toLowerCase();
                  return (
                    <Link
                      to={createLocaleLink(locale)}
                      key={lang}
                      title={this.getLanguageName(lang)}
                      data-locale={`${lang}-${country.id}`}
                      className={cn(
                        'CountrySelect-language',
                        lc === locale && 'CountrySelect-language--selected',
                      )}
                      onClick={this.onClickLanguage}
                    >
                      {lang}
                    </Link>
                  );
                })
              }</div>
            ),
            value: country.id,
            selected,
          };
        })}
        className="CountrySelect-options-list"
        width={265}
        align="center"
        fromTop={fromTop}
        onSelect={this.onSelect}
        {...rest}
      >
        <div className={`CountrySelect-trigger ${light && 'CountrySelect-trigger--light'}`}>
          <img src={flags[region]} alt={region} className="CountrySelect-flag" />
        </div>
      </OptionsList>
    );
  }
}

export default CountrySelect;



// WEBPACK FOOTER //
// ./spa/Components/Header/CountrySelect.jsx